import React from 'react';

import MailchimpSignUp from './form';

const SignUp = ({ invertedColours = false }) => {

  return (
    <div className={ `${ invertedColours ? "sign-up sign-up-alt" : "sign-up" }` }>
      <div className="sign-up-empty-col"></div>
      <div className="sign-up-wrapper">
        <MailchimpSignUp />
      </div>
    </div>
  )
}

export default SignUp;